<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>论文检查</h3>
                <p></p>
            </div>
            <div class="info-main">
                <!-- <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>类型：</p>
                    <a-select class="input" @blur="check()" allowClear v-model="info.checkType" :disabled="type=='look' || type=='edit' || type=='midterm'">
                        <a-select-option  value="中期检查">中期检查</a-select-option>
                        <a-select-option  value="期末检查">期末检查</a-select-option>
                    </a-select>
                </div> -->
                <div class="input-box input-box-huge">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>论文题目：</p>
                    <a-input class="input" v-model="info.paperTitle" :disabled="type=='look'|| type=='midterm'"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>学年：</p>
                    <a-date-picker
                        :disabled="type=='look'|| type=='midterm'"
                        class="input"
                        mode="year"
                        format='YYYY'
                        v-model="year" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        @panelChange="panelChangeOne">
                        <a-input  v-model="info.schoolYear" :disabled="type=='look'|| type=='midterm'"/>
                    </a-date-picker>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>学期：</p>
                    <a-select class="input" allowClear v-model="info.semester" :disabled="type=='look'|| type=='midterm'">
                        <!-- For years before 2025, keep all options -->
                        <template v-if="year < '2025'">
                            <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                        </template>
                        <!-- For 2025 and later, only show two semesters -->
                        <template v-else>
                            <a-select-option :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                        </template>
                    </a-select>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>导师：</p>
                    <a-select
                        :disabled="type=='look'|| type=='midterm'"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.teacherId"
                        @change="teacherSelect"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <!-- <div class="input-box">
                    <p>系别：</p>
                    <a-select class="input" allowClear v-model="info.orgCode" >
                        <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div> -->
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>学生姓名：</p>
                    <a-input class="input" v-model="info.studentName" :disabled="type=='look'|| type=='midterm'"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>学号：</p>
                    <a-input class="input" v-model="info.studentNo" :disabled="type=='look'||type=='edit'|| type=='midterm'"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>所在专业：</p>
                    <a-select
                        :disabled="type=='look'|| type=='midterm'"
                        class="input" 
                        allowClear
                        v-model="info.subjectCode"
                        @change="subjectSelect"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in zyArr" :key="index" :value="item.dataCode" :label="item.dataName">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                
                <!-- <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem" v-show="info.checkType=='期末检查'"> *</span>检查结果：</p>
                    <a-select class="input" default-value="可参加答辩" allowClear v-model="info.checkLevel" :disabled="type=='look'">                        
                        <a-select-option  value="可参加答辩">可参加答辩</a-select-option>
                        <a-select-option  value="修改后答辩">修改后答辩</a-select-option>
                        <a-select-option  value="重大修改后答辩">重大修改后答辩</a-select-option>
                        <a-select-option  value="不能答辩">不能答辩</a-select-option>
                    </a-select>
                </div> -->
                
            </div>
        </div>
        <div class="info-box" v-if="type=='midterm' || type=='look'">
            <div class="info-title">
                <h3>中期检查意见</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-large">
                    <p>{{info.checkType}}意见：</p>
                    <a-textarea class="input" v-model="info.middleComment" :rows="4" :disabled="type=='look'"/>
                </div>
            </div>
        </div>
        <!-- <div v-show="info.middleComment==''">
            <a-alert
                message="提示"
                description="尚未进行中期检查"
                type="warning"
                show-icon
            />
        </div> -->
        <div class="info-box" v-if="type=='look'" >
            <div class="info-title">
                <h3>学院自查质量评价表</h3>
                <p></p>
            </div>
            <div class="info-main" v-if="data != null">
                <div class="table">
                    <a-table
                        :columns="columns"
                        :data-source="data"
                        bordered
                        size="middle"
                        :pagination="{ defaultPageSize	: 20,hideOnSinglePage:true}">
                    <template
                        v-for="col in ['indexScore']"
                        :slot="col"
                        slot-scope="text, record, index"
                        >
                        <div :key="col">
                            <a-input-number
                            v-if="true"
                            style="margin: -5px 0"
                            :value="text"
                            disabled
                            />
                            <template v-else>
                            {{ text }}
                            </template>
                        </div>
                        </template>
                    </a-table>
                </div>
            </div>
            <div v-show="data == null">
            <a-alert
                message="尚未进行学院自查"
                description=""
                type="warning"
                show-icon
            />
        </div>
        </div>
        <div class="info-main" v-if="data != null && type=='look'">      
            <div class="input-box input-box-large">
                <p>学院自查评阅意见：</p>
                <a-textarea class="input" v-model="info.collegeComment" :rows="4" disabled/>
            </div>
        </div>
        <div v-if="data != null&& type=='look'">      
            <div class="pyr">
                <p>评阅人：</p>
                <span  style="margin-right:2rem">{{info.collegeUserName}}</span>
                <p>评阅时间：</p>
                <span >{{info.collegeDate}}</span> 
            </div>
        </div>
        <div class="info-box" v-if="type=='midterm' || type=='look'">
            <div class="info-title">
                <h3>归档材料的完整性和规范性检查反馈意见</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-large">
                    <p>{{info.checkType}}意见：</p>
                    <a-textarea class="input" v-model="info.integrityNormativeComment" :rows="4" :disabled="type=='look'"/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">返回</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,check,middleInspect} from '@/baseAPI/undergraduate/culture/paperCheck'
    import { getDicts } from '@/baseAPI/dictionary'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'

    const columns = [

        {
            title: '考评项目',
            dataIndex: 'indexPname',
            width: 150,
            fixed: 'left',
            align:'center',
            // colSpan:2,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 1) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 5) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 6) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 7) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 8) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 9 || index === 10) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 11) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 12) {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            },
        },
        {
            title: '权重',
            dataIndex: 'indexPscore',
            width: 50,
            fixed: 'left',
            align:'center',
            // colSpan:0,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 1) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 5) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 6) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 7) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 8) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 9 || index === 10) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 11) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 12) {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            },
        },
        {
            title: '考评指标',
            dataIndex:'indexTitle',
            width: 200,
            // colSpan:2,
            align:'center',
            customRender: (value, row, index) => {
                // const obj = {
                //     children: value,
                //     attrs: {},
                // };
                // if(index == 12){
                //     obj.attrs.colSpan = 0;
                // }
                // return obj;
                return value;
            }
        },
        {
            title: '分值',
            dataIndex:'indexFullScore',
            width: 50,
            // colSpan:0,
            align:'center',
            customRender: (value, row, index) => {
                // const obj = {
                //     children: value,
                //     attrs: {},
                // };
                // if(index == 12){
                //     obj.attrs.colSpan = 2;
                // }
                // return obj;
                return value;
            }
        },
        {
            title: '评价要求或要素',
            dataIndex:'indexContent',
            width: 700,
            align:'left',
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                // if (index === 9) {
                //     obj.attrs.rowSpan = 3;
                // }
                // if (index === 10 || index === 11) {
                //     obj.attrs.rowSpan = 0;
                // }
                return obj;
            },
        },
        {
            title: '得分',
            dataIndex: 'indexScore',
            width: 100,
            fixed: 'right',
            align:'center',
            scopedSlots: { customRender: 'indexScore' },
        },
        ]

    export default {
        name: '',
        data () {
            return {
                year:'',
                yearShowOne:false,
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                type:'',
                info:{
                    schoolYear: "",
                    semester: "",
                    orgCode: "",
                    orgName: "",
                    teacherName: "",
                    teacherId: "",
                    studentName: "",
                    studentNo: "",
                    paperTitle: "",
                    judgeTeacherId: "",
                    judgeTeacherName: "",
                    checkLevel: "",
                    middleComment: "",
                },
                xbArr:[],
                jsArr:[],
                zyArr:[],
                data:[],
                columns,
            }
        },
        mounted () {
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.info.semester=getSemester()
            this.type=this.$route.query.type;
            this.info.judgeTeacherName=this.$store.state.user.name
            this.info.judgeTeacherId=this.$store.state.user.userId
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'BKZY',status:true}).then(res=>{
                this.zyArr=res.data.dicts;
            })

            getTeacher().then(res=>{
                this.jsArr=res.data;
            })

            if(this.type!='add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data;
                        this.data=res.data.inspectDetails

                        var totalScore=0.0
                        this.data.forEach((item,index)=>{
                            if(item.indexScore != '' && item.indexScore !=null && index < 13){
                                totalScore += parseFloat(item.indexScore)
                            }
                        })
                        this.data[13].indexScore = totalScore 
                        console.log("indexScore:"+this.data[13].indexScore)
                    })
                },500)
            }
        },
        methods:{
            check(){
                if(this.info.studentNo != "" && this.info.checkType !=""){
                    check({checkType:this.info.checkType,studentNo:this.info.studentNo}).then(res=>{
                        if(res.data.success){
                            // this.$notification['success']({
                            //     message: '成功',
                            //     description:'校验通过',
                            // });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.teacherId){
                        this.info.teacherId=this.jsArr[i].teacherId
                        this.info.teacherName=this.jsArr[i].teacherName
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                    }
                }
            },
            subjectSelect(){
                for(let i=0;i<this.zyArr.length;i++){
                    if(this.zyArr[i].dataCode==this.info.subjectCode){
                        this.info.subjectCode=this.zyArr[i].dataCode
                        this.info.subjectName=this.zyArr[i].datarName
                    }
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.info.semester='';
                this.yearShowOne = false;
            },
            handleChange(value, key, column) {                
                const newData = [...this.data];
                const target = newData.filter(item => key === item.indexId)[0];
                
                if (target) {
                    target[column] = value;
                    this.data = newData;
                }
                this.info.totalScore = 0.0
                this.data.forEach((item,index)=>{
                    if(item.indexScore != '' && index < 12){
                        this.info.totalScore += parseFloat(item.indexScore)
                    }
                })
                this.data[12].indexScore = this.info.totalScore 

            },
            onChange(e){
                this.info.tysj = e.target.value
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                // var arr=['checkLevel']
                // for(let i=0;i<arr.length;i++){
                //     if((this.info[arr[i]]==null||this.info[arr[i]]==='')&&this.info.checkType=='期末检查'){
                //         isSub=false;
                //         break;
                //     }
                // }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增论文抽查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else if(this.type=='midterm'){
                        middleInspect(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'论文中期检查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改论文抽查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }

    .info-main .table{
        margin-left: 10rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }

    .pyr{
        justify-content: flex-end;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        margin-right: 12rem;
        /* position: relative; */
    }

    .info-main .input-box-center{
        width: 66%;
    }

    .info-main .input-box-large{
        width: 88%;
    }

    .info-main .input-box-huge{
        width: 99%;
    }

    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
